import { SectionContainer } from '@/components/shared'
import { websiteContent } from '../content'
import { usePanelViewTracking } from '../hooks/usePanelViewTracking'

const { services } = websiteContent

function ServiceScrollSection() {
  usePanelViewTracking({
    panelId: 'services',
    panelName: 'Services',
    panelIndex: 3,
  })

  return (
    <SectionContainer
      id="services"
      size="page"
      className="bg-brand-green min-h-[1469px] text-white md:min-h-0"
      innerClassName="relative !px-page-gutter xl:!px-page-gutter 3xl:!px-content-inset-wide"
    >
      <div className="flex flex-col gap-[111px] pb-14 pt-[111px] md:min-h-[1056px] md:gap-[72px] md:py-[72px] 3xl:min-h-[1024px] 3xl:justify-center 3xl:py-0">
        <div className="w-full max-w-[345px] md:max-w-[924px] xl:pl-[118px] 3xl:pl-0">
          <p className="font-archivo text-[12px] font-extralight uppercase leading-[14px] text-white md:leading-[16px]">
            {services.title}
          </p>
          <h2 className="mt-[72px] max-w-[255px] whitespace-normal font-archivo text-[52px] font-extralight leading-[56px] text-brand-greenBright md:max-w-none md:text-h1">
            {services.subtitle}
          </h2>
          <p className="mt-[56px] font-archivo text-[32px] font-extralight leading-[46px] text-white md:text-h2 md:leading-[60px]">
            {services.description}
          </p>
        </div>

        <div className="w-full max-w-[345px] space-y-6 md:max-w-none md:grid md:grid-cols-3 md:gap-6 md:space-y-0 xl:px-[118px] 3xl:px-0">
          {services.groups.map((group) => (
            <section
              key={group.title}
              className="flex h-full flex-col gap-2 bg-gray-darkest/20 p-10 md:min-h-[348px] md:gap-8"
            >
              <h3 className="font-agency text-[100px] font-black uppercase leading-[100px] tracking-[1px] text-brand-greenBright">
                {group.title}
              </h3>
              <p className="text-h3 font-archivo font-light text-white">
                {group.description}
              </p>
            </section>
          ))}
        </div>
      </div>
    </SectionContainer>
  )
}

export default ServiceScrollSection
